import React, { useEffect, useState } from "react";
import "../css/team.scss";
import { serverInstance } from "../service/axios";

const Team = ({ data, language }) => {

  const [boardMembers, setBoardMembers] = useState([]);

  const getBoardMembers = () => {
    serverInstance.get("/app/board-members", {
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(res => {
      const level2members = res.data.items.filter(member => member.level === 2);
      const level3members = res.data.items.filter(member => member.level === 3);
      setBoardMembers([level2members, level3members])
    })
  }

  useEffect(() => {
    getBoardMembers();
  }, []);

  return (
    <div id="team" className="team">
      <div className="team-title">
        <span className="text">{data.title}</span>
      </div>
      <div className="team-container">
        {boardMembers.map((team, index) => (
          <div key={index} className="member-row" >
            {team.map((member, idx) => (
              <div key={idx} className="person">
                <div className="person-inner">
                 <div className={'rounded-circle d-flex justify-content-center align-items-center ' + (member.fileUrl ? ' bordered' : '')}
                  style={{ objectFit: "cover", width: 120, height: 120 }}>
                    <img src={member.fileUrl ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${member.fileUrl}` : "images/team/member.png"} className="profile-png" />
                  </div>
                  <div className="person-name">{!language ? `${member.last_name[0]}.${member.first_name}` : `${member.first_name_en} ${member.last_name_en}`}</div>
                  <div className="person-title">{language && member.position_en ? member.position_en : member.position}</div>
                  <div className="person-info">{language && member.description_en ? member.description_en : member.description}</div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
